module.exports = __webpack_public_path__ + "img/complete-vehicle.8e39bc7b.png";